import {Component} from '@angular/core';
/**
 * \@title Basic button-toggles
 */
export class ButtonToggleOverviewExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'button-toggle-overview-example',
  templateUrl: 'button-toggle-overview-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ButtonToggleOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
ButtonToggleOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ButtonToggleOverviewExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
